import { AssistantText } from "./AssistantText";
import { DynamicToolOrTask } from "./DynamicToolOrTask";
import {
  FlattenedPart,
  MessageFlags,
} from "@src/features/ai/components/WorkflowEditor/execution/types";

import { Reasoning } from "./Reasoning";
import { ReasoningStep } from "./ReasoningStep";

type AssistantContentBuilderProps = {
  item: FlattenedPart;
  index: number;
  isStreaming?: boolean;
  isLast?: boolean;
  timestamp?: number;
  hiddenReasoningPartIds?: Set<string>;
} & MessageFlags;

export const AssistantContentBuilder = (
  props: AssistantContentBuilderProps
) => {
  const { item, ...rest } = props;

  if (item.part.type === "text") {
    return <AssistantText item={item} part={item.part} {...rest} />;
  }

  if (item.part.type === "dynamic-tool") {
    return <DynamicToolOrTask item={item} part={item.part} {...rest} />;
  }

  if (
    item.part.type === "reasoning" &&
    item.nodeType === "condition" &&
    !props.showConditionNodes
  ) {
    return null;
  }

  // Thought-process timeline: model reasoning renders as a "Thought about this
  // step" row instead of the raw reasoning panel / streaming spinner.
  if (props.showToolsAsSteps && item.part.type === "reasoning") {
    return <ReasoningStep part={item.part} />;
  }

  if (props.showReasoningMessages && item.part.type === "reasoning") {
    return (
      <Reasoning
        item={item}
        part={item.part}
        isCondition={item.nodeType === "condition"}
        {...rest}
      />
    );
  }

  return null;
};
